// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

// import PDFMerger from 'pdf-merger-js/browser';
// UI Lib

import { Box } from '@chakra-ui/react'

// Component
import { useCustomer } from '@/features/customers/useCustomer'
import DocumentDetailModal from '@/features/offers/components/Modal/DocumentDetailModal/DocumentDetailModal'
import SOPQuestionnaireModal from '@/features/offers/components/Modal/SOPQuestionnaireModal'

import OfferHeader from '@/features/offers/offer-detail/components/OfferHeader/OfferHeader'

// API

//Slice
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import { authSelector } from '@/stores/auth/authSlice'

// Constant

import VendorQuotationSelectionModal from '@/features/offers/components/Modal/VendorQuotationSelectionModal'
import { formatOffer, formatOfferFromServer } from '@/features/offers/helpers/formatOffer'
import { validateSOPSubmission } from '@/features/offers/helpers/sop.helper'
import useOffer from '@/features/offers/hooks/useOffer'
import OfferFooter from '@/features/offers/offer-detail/components/OfferFooter/OfferFooter'
import OfferTabs from '@/features/offers/offer-detail/tabs/OfferTabs'
import { toast } from 'react-toastify'
import { RoleInOffer } from '@eapproval/offer-shared'
import { selectOfferDetail } from '../../slices/offerDetail.slice'

const OfferForm = ({ offer }) => {
  // Redux Variable
  const { user } = useSelector(authSelector)

  const { role } = useSelector(selectOfferDetail)

  const [tabIndex, setTabIndex] = useState(
    role === RoleInOffer.PROCUREMENT_OFFICER
      ? 5
      : [RoleInOffer.GCPR_APPROVER, RoleInOffer.GCPR_APPROVER_DELEGATEE].includes(role)
        ? 7
        : 0
  )

  // Hooks
  const dispatch = useDispatch()

  const offerFormRef = useRef()

  const methods = useForm({
    defaultValues: offer,
  })

  //Fetch
  const { useUpdateOffer } = useOffer()
  const { useFetchAllCustomers } = useCustomer()
  const { refetch: refetchCustomerOptions } = useFetchAllCustomers({ page: 1, pageSize: 0 })
  const updateOffer = useUpdateOffer()

  useEffect(() => {
    if (offer) {
      methods.reset(formatOfferFromServer(offer))
    }
  }, [offer, methods])

  const onSave = async (data) => {
    const dirtyFields = methods.formState.dirtyFields

    // Remove SOPQuestionAnswers if countryOfInstallation is not HK

    try {
      dispatch(showLoadingOverlay())
      const country = (data?.countryOfInstallation || '').toLowerCase()
      if (country && country !== 'hk') {
        data.SOPQuestionAnswers = {
          isCountryOfInstallHK: null,
          isMainContractSignedAfterAug2025: null,
          isOver5Million: null,
          isPublicContract: null,
          isNewBuildingProject: null,
          isValueOfWorkRequiredBAApproval: null,
          isNonResidentialOver5Million: null,
        }
        data.securityOfPayment = false
        data.isSOP = false
      } else {
        validateSOPSubmission({
          offerCreateDate: new Date(data.createdAt),
          countryOfInstallation: data.countryOfInstallation,
          isEQuotation: data.isEQuotation,
          SOPQuestionAnswers: data.SOPQuestionAnswers,
        })
      }

      const formattedOffer = formatOffer(data)
      await updateOffer.mutateAsync({ id: data.id, data: formattedOffer })
    } catch (error) {
      //TODO: Add back error handle for switch tab
      console.error(error)
      toast.error(`Failed to save offer: ${error.message}`)
    } finally {
      refetchCustomerOptions()
      dispatch(hideLoadingOverlay())
    }
  }

  if (!offer) {
    return <p>No Offer</p>
  }

  return (
    <>
      <FormProvider {...methods}>
        <DocumentDetailModal />
        <VendorQuotationSelectionModal />
        <SOPQuestionnaireModal />

        <Box
          w="100%"
          px={9}
          bg="white"
          as="form"
          h="90%"
          pb="100px"
          ref={offerFormRef}
          onSubmit={(e) => {
            methods.clearErrors()
            e.preventDefault()
            methods.handleSubmit(onSave)(e)
          }}
        >
          <OfferHeader />
          <OfferTabs tabIndex={tabIndex} setTabIndex={setTabIndex} />
          <OfferFooter tabIndex={tabIndex} setTabIndex={setTabIndex} />
        </Box>
      </FormProvider>
    </>
  )
}

export default OfferForm
